import type React from 'react';
import styles from './Form.module.scss';

type FormCheckBoxButtonProps = {
  id: string;
  label: string;
  checked: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const FormCheckBoxButton: React.FC<FormCheckBoxButtonProps> = ({ id, label, checked, onClick }) => {
  const onClickButton = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onClick(e);
  }

  return (
    <button
      type="button"
      onClick={(e) => onClickButton(e)}
      className={`badge badge-pill ${styles.formCheckBoxButton} ${checked ? styles.checked : ''}`}
    >
      <span>{label}</span>
    </button>
  );
}

export default FormCheckBoxButton;
